import React from 'react';
import { Box } from '@mui/material';
import useMediaQuery from '@mui/system/useMediaQuery';
import colors from '../../theme/colors';
import { breakpoints } from '../../theme';
import * as T from '../Typography';
import creditCardSvg from '../assets/credit-card.svg';

import { Wrapper, IconWrapper } from './style';

type SurveyCardProps = {
  paymentDueDate: string;
};

const PaymentPendingCard: React.FC<SurveyCardProps> = ({ paymentDueDate }) => {
  const isWideScreen = useMediaQuery(`(min-width:${breakpoints.tablet}px)`);

  return (
    <Wrapper flexDirection={isWideScreen ? 'row' : 'column'}>
      <IconWrapper>
        <img src={creditCardSvg} alt="Credit Card Icon" />
      </IconWrapper>
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        mb={isWideScreen ? 0 : 3}
      >
        <T.TextMediumBold
          color={colors.neutral.shades.shade700}
          ta={isWideScreen ? 'left' : 'center'}
        >
          Payment pending for your survey
        </T.TextMediumBold>
        <T.TextSmallRegular
          mt={2}
          color={colors.neutral.shades.shade600}
          ta={isWideScreen ? 'left' : 'center'}
        >
          Your survey has been submitted. To get your results, please pay within 30 days of receiving your invoice or payment link.
        </T.TextSmallRegular>
      </Box>
    </Wrapper>
  );
};

export default PaymentPendingCard;
